import api from './api';

export const getQuestionnaires = (params) => api.get('/api/questionnaires', { params });
export const getQuestionnaire = (id) => api.get(`/api/questionnaires/${id}`);
export const createQuestionnaire = (data) => api.post('/api/questionnaires', data);
export const updateQuestionnaire = (id, data) => api.put(`/api/questionnaires/${id}`, data);
export const deleteQuestionnaire = (id) => api.delete(`/api/questionnaires/${id}`);
